// Translations
import form from '../sections/form/translations/tr'

// Translation: Terms of service > Landing (Turkish)
export default Object.freeze({
	sections: { form }
})
